'use strict';
module.exports = function isUploadableImage(imageUrl) {
	return !!imageUrl && /^data:image\/[a-z]+;base64,[A-z0-9=+/]+$/.test(imageUrl);
};

